import { render, staticRenderFns } from "./Pc.vue?vue&type=template&id=34f1e32c&scoped=true&"
import script from "./Pc.vue?vue&type=script&lang=js&"
export * from "./Pc.vue?vue&type=script&lang=js&"
import style0 from "./Pc.vue?vue&type=style&index=0&id=34f1e32c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f1e32c",
  null
  
)

export default component.exports